"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playHitSpike = exports.playPickupWeb = exports.playHitBySpider = exports.playHitSpider = exports.playHitLavaQuiet = exports.playHitLava = exports.playSlimedQuiet = exports.playSlimed = exports.playHitByGoblin = exports.playHitGoblin = exports.playPickupAmulet = exports.playPickupSword = exports.playPickupHeart = exports.playPickupKey = exports.playUnlock = exports.playEffectGhosted = exports.playHitByTroll = exports.playHitByRat = exports.playHitRat = exports.playHitByBat = exports.playHitBat = exports.playHitTroll = exports.playHitWraith = exports.playHitGhost = exports.playHitBlob = exports.playHitJelly = exports.playEat = exports.playCrateBroke = exports.playCrateHit = exports.playHitStairsDown = exports.playHitEnemy = exports.playHitBlockQuiet = exports.playHitBlock = exports.playPickup = exports.playPieceInHole = exports.playPieceContactsBoundary = exports.playPieceContactsPole = exports.playPieceContactsPiece = exports.playLoaded = exports.load = exports.getMusicPath = void 0;
var log_sidecar_1 = require("@engine/log-sidecar");
var soundsGeneric_sidecar_1 = require("@engine/soundsGeneric-sidecar");
var _audioSprite2_sidecar_1 = require("proto/goat/sound/_audioSprite2-sidecar");
var doPlayLoaded = false;
var soundTest = false;
var _musicPath = '';
function getMusicPath() {
    return _musicPath;
}
exports.getMusicPath = getMusicPath;
var logNamespace = 'sounds';
function load(audioJson, musicPath) {
    _musicPath = musicPath + '/';
    soundsGeneric_sidecar_1.soundsGeneric.load(audioJson, function () {
        log_sidecar_1.log.x(logNamespace, 'loaded');
        if (doPlayLoaded) {
            playLoaded();
        }
        if (soundTest) {
            setInterval(function () {
                playLoaded();
            }, 500);
        }
    });
    // playMusicMenu()
}
exports.load = load;
function playLoaded() {
    playPieceInHole();
}
exports.playLoaded = playLoaded;
function playPieceContactsPiece() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playPieceContactsPiece = playPieceContactsPiece;
function playPieceContactsPole() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playPieceContactsPole = playPieceContactsPole;
function playPieceContactsBoundary() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playPieceContactsBoundary = playPieceContactsBoundary;
function playPieceInHole() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood2]);
    // soundsGeneric.playRandom([
    //   _audioSprite2.Button_01,
    //   _audioSprite2.Button_01_Variation_01,
    //   _audioSprite2.Button_01_Variation_02,
    //   _audioSprite2.Button_01_Variation_03,
    // ])
}
exports.playPieceInHole = playPieceInHole;
function playPickup() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.pickup1]);
}
exports.playPickup = playPickup;
function playHitBlock() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playHitBlock = playHitBlock;
function playHitBlockQuiet() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1], 0.5);
}
exports.playHitBlockQuiet = playHitBlockQuiet;
function playHitEnemy() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood1]);
}
exports.playHitEnemy = playHitEnemy;
function playHitStairsDown() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.wood2]);
}
exports.playHitStairsDown = playHitStairsDown;
function playCrateHit() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitcrate]);
}
exports.playCrateHit = playCrateHit;
function playCrateBroke() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.createbreak2]);
}
exports.playCrateBroke = playCrateBroke;
function playEat() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.eat1]);
}
exports.playEat = playEat;
function playHitJelly() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.jellyhit]);
}
exports.playHitJelly = playHitJelly;
function playHitBlob() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.blobhit]);
}
exports.playHitBlob = playHitBlob;
function playHitGhost() { }
exports.playHitGhost = playHitGhost;
function playHitWraith() { }
exports.playHitWraith = playHitWraith;
function playHitTroll() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.trollhit]);
}
exports.playHitTroll = playHitTroll;
function playHitBat() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.batdeath]);
}
exports.playHitBat = playHitBat;
function playHitByBat() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.bit]);
}
exports.playHitByBat = playHitByBat;
function playHitRat() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.ratdeath]);
}
exports.playHitRat = playHitRat;
function playHitByRat() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.bit]);
}
exports.playHitByRat = playHitByRat;
function playHitByTroll() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitbytroll]);
}
exports.playHitByTroll = playHitByTroll;
function playEffectGhosted() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.ghost1]);
}
exports.playEffectGhosted = playEffectGhosted;
function playUnlock() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.unlock]);
}
exports.playUnlock = playUnlock;
function playPickupKey() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.pickupkey]);
}
exports.playPickupKey = playPickupKey;
function playPickupHeart() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.pickupheart]);
}
exports.playPickupHeart = playPickupHeart;
function playPickupSword() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.pickupsword]);
}
exports.playPickupSword = playPickupSword;
function playPickupAmulet() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.pickupheart]);
}
exports.playPickupAmulet = playPickupAmulet;
function playHitGoblin() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitgoblin]);
}
exports.playHitGoblin = playHitGoblin;
function playHitByGoblin() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitbygoblin2]);
}
exports.playHitByGoblin = playHitByGoblin;
function playSlimed() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitslime]);
}
exports.playSlimed = playSlimed;
function playSlimedQuiet() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitslime], 0.5);
}
exports.playSlimedQuiet = playSlimedQuiet;
function playHitLava() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitlava]);
}
exports.playHitLava = playHitLava;
function playHitLavaQuiet() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitlava], 0.5);
}
exports.playHitLavaQuiet = playHitLavaQuiet;
function playHitSpider() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitspider]);
}
exports.playHitSpider = playHitSpider;
function playHitBySpider() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.bit]);
}
exports.playHitBySpider = playHitBySpider;
function playPickupWeb() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitweb]);
}
exports.playPickupWeb = playPickupWeb;
function playHitSpike() {
    soundsGeneric_sidecar_1.soundsGeneric.playRandom([_audioSprite2_sidecar_1._audioSprite2.hitspike], 0.5);
}
exports.playHitSpike = playHitSpike;
